export default __webpack_public_path__ + "static/media/startengine.e5a5eca9.png";